// ============================================================================
// VOUCHER PRINTING ENDPOINTS (ADR-0062)
// ============================================================================
// Sales invoice outputs: SalesInvoicePrintController (api/v1/sales-invoices/{id}/print).
// Settings: PrintLayoutsController (api/v1/print-layouts).

import { buildEndpoint, buildEndpointWithParams } from './base.endpoints';
import type { ID } from '../types';

const SALES_INVOICE_PRINT_BASE = '/sales-invoices/:id/print';

export const salesInvoicePrintEndpoints = {
  options: (id: ID) => buildEndpointWithParams(`${SALES_INVOICE_PRINT_BASE}/options`, { id }),
  pdf: (id: ID) => buildEndpointWithParams(`${SALES_INVOICE_PRINT_BASE}/pdf`, { id }),
  mailDraft: (id: ID) => buildEndpointWithParams(`${SALES_INVOICE_PRINT_BASE}/mail-draft`, { id }),
  log: (id: ID) => buildEndpointWithParams(`${SALES_INVOICE_PRINT_BASE}/log`, { id }),
} as const;

const PRINT_LAYOUTS_BASE = '/print-layouts';

export const printLayoutEndpoints = {
  documentTypes: () => buildEndpoint(`${PRINT_LAYOUTS_BASE}/document-types`),
  profile: (documentType: string) => buildEndpointWithParams(`${PRINT_LAYOUTS_BASE}/profiles/:documentType`, { documentType }),
  copy: (documentType: string) => buildEndpointWithParams(`${PRINT_LAYOUTS_BASE}/profiles/:documentType/copy`, { documentType }),
  preview: (documentType: string) => buildEndpointWithParams(`${PRINT_LAYOUTS_BASE}/profiles/:documentType/preview`, { documentType }),
  image: (documentType: string, kind: 'logo' | 'signature') =>
    buildEndpointWithParams(`${PRINT_LAYOUTS_BASE}/profiles/:documentType/images/:kind`, { documentType, kind }),
  emailTemplate: (documentType: string) => buildEndpointWithParams(`${PRINT_LAYOUTS_BASE}/email-templates/:documentType`, { documentType }),
  contacts: () => buildEndpoint(`${PRINT_LAYOUTS_BASE}/contacts`),
  states: () => buildEndpoint(`${PRINT_LAYOUTS_BASE}/states`),
} as const;
